import React, { useState } from "react";
import { motion } from "framer-motion";
import ProjectCard from "./ProjectCard";

const ProjectWrapper = () => {
const [projectData, setProjectData] = useState([
  {
    name: "SQLMagic",
    description:
      "A React.js web application that allows users to run SQL queries, view mock query results, and toggle between predefined queries and their corresponding data tables. It also supports viewing large SQL table data from CSV files.",
    link: "https://sqlmagic.vercel.app/",
    imageLink: "https://sumsky.top/img/sql-notes/com037-scaled.jpg",
  },
  {
    name: "Connect Together",
    description:
      "Hackathon winning Project Developed in group for the Parent, Student and Teacher ",
    link: "https://connect-together-six.vercel.app/",
    imageLink:
      "https://th.bing.com/th/id/OIP.XM432sgftsyufwaH0i7_6QHaEK?rs=1&pid=ImgDetMain",
  },
  {
    name: "MedGenAI (Hackathon Project)",
    description:
      "AI-driven platform for disease diagnosis, treatment plans, and doctor recommendations with molecular analysis.",
    link: "https://github.com/DevDynamo01/ATMEC-Medical-Project-/tree/main",
    imageLink:
      "https://th.bing.com/th/id/OIP.DAxwsl4RXlRlQaUpnBrhgQHaDt?rs=1&pid=ImgDetMain",
  },
  {
    name: "ScamShield (Hackathon Project)",
    description:
      "This is Hackathon Group Project for the Scam and Fraud Call detection",
    link: "https://github.com/DevDynamo01/ScamShield/tree/main",
    imageLink:
      "https://miro.medium.com/v2/resize:fit:1358/1*a2cTeCxooNiuYruaUlIvrw.jpeg",
  },

  {
    name: "Real Time Chat Application",
    description:
      "I developed a chat application that allows users to send messages (both text and images) in real-time. The application includes",
    link: "https://github.com/Suryanra/chat-application/tree/my-new-branch",
    imageLink:
      "https://th.bing.com/th?id=OIP.g6SHLLC5t_fAvoimM5gObQHaFj&w=288&h=216&c=8&rs=1&qlt=90&o=6&dpr=1.5&pid=3.1&rm=2",
  },

  {
    name: "Note  Chrome Extension",
    description:
      "This Chrome extension allows users to easily add selected text from the browser into a notepad. ",
    link: "https://github.com/Suryanra/Notes-making-extension/tree/my-new-branch",
    imageLink:
      "https://th.bing.com/th/id/OIP.DCEjIZOOEn-ZmjLugD3y8QHaEK?rs=1&pid=ImgDetMain",
  },
  {
    name: "Music Player",
    description:
      "A music player developed during my web development learning phase. It features song selection, play/pause functionality, and dark/light mode options.",
    link: "https://suryanra.github.io/Music_player/",
    imageLink:
      "https://th.bing.com/th/id/OIP.8Q_kB_LN3XFdfQvH8COppAHaEK?rs=1&pid=ImgDetMain",
  },
  {
    name: "Blog Website",
    techUsed: ["HTML", "CSS", "JavaScript", "HBS", "NodeJS"],
    description:
      "A simple blog website where users can post, edit, and delete blogs. The website includes features such as liking posts, and user authentication with ",
    link: "https://github.com/Suryanra/blog-website-/tree/master",
    imageLink:
      "https://th.bing.com/th/id/OIP.ESRdcspNaVgPqpkh5OALZgHaD0?rs=1&pid=ImgDetMain",
    date: "October 2023",
  },
  {
    name: "Netflix Landing Page Clone",
    techUsed: ["HTML", "CSS", "JavaScript"],
    description:
      "A clone of the Netflix landing page built using HTML and CSS to replicate the look and feel of the original site.",
    link: "https://suryanra.github.io/my-first-project-netflix-clone/",
    imageLink:
      "https://th.bing.com/th/id/OIP.kR055Omrb8EodGXtZB0GbQHaEK?rs=1&pid=ImgDetMain",
    date: "August 2023",
  },
  {
    name: "Tic-Toe game",
    description:
      "HTML, CSS, javascript based Project, having both multiplayer and playing against the robot",
    link: "https://suryanra.github.io/tic_toe_game/",
    imageLink:
      "https://th.bing.com/th/id/OIP.wS5uDdEDnQJSkWZSLgVq1QHaFo?rs=1&pid=ImgDetMain",
  },
  {
    name: "To-Do Application",
    description: "React.js Based frontend Project for the To do list",
    link: "https://github.com/Suryanra/react-todo-app",
    imageLink:
      "https://clickup.com/blog/wp-content/uploads/2019/01/to-do-list-apps-1400x1050.png",
  },
  {
    name: "QR Code generator",
    description:
      "Simple HTML, CSS and javascript based web application for QR code generator",
    link: "https://suryanra.github.io/qr-code-generator/",
    imageLink:
      "https://th.bing.com/th/id/R.6f9d43bfa9d53235a7b6bc310fb5448b?rik=xUE6OknSO1WYUg&riu=http%3a%2f%2fwww.pngall.com%2fwp-content%2fuploads%2f2%2fQR-Code-PNG-Images.png&ehk=HPmT%2bF4%2ftU1Kn0R5oF8b%2ffA4ks46kTqApdr3kn7DzIg%3d&risl=&pid=ImgRaw&r=0",
  },
]);

  return (
    <div className="ProjectWrapper" id="Project">
      <div className="projectHeading">Projects</div>
      <div className="project_container">
        {projectData.map((item, index) => (
          <motion.div
          className="motiondiv"
            key={index}
            initial={{ opacity: 0, x: index % 2 === 0 ? -100 : 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}>
            <ProjectCard data={item} />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProjectWrapper;
